import React from "react";
import CommonModal from "../../../components/Common/CommonModal";
import CommonButton from "../../../components/buttons/CommonButton";
import PropTypes from "prop-types";
import { useDropzone } from "react-dropzone";

function AdicionarArquivoModal({
  modalHook,
  valuesHook,
  salvarDocumento,
  previewsHook,
}) {
  const { adicionarArquivoModal, setAdicionarArquivoModal } = modalHook;
  const { values, setValues } = valuesHook;
  const { previews, setPreviews } = previewsHook;

  const { getRootProps, getInputProps } = useDropzone({
    onDrop: (acceptedFiles) => {
      const newFiles = acceptedFiles.map((file) => ({
        file,
        preview: file.type.startsWith("image/")
          ? URL.createObjectURL(file)
          : null,
      }));
      setPreviews((prev) => [...prev, ...newFiles]);
      setValues({
        ...values,
        files: [...(values.files || []), ...acceptedFiles],
      });
    },
    multiple: true,
  });

  React.useEffect(() => {
    return () =>
      previews.forEach((p) => p.preview && URL.revokeObjectURL(p.preview));
  }, [previews]);

  const removeFile = (index) => {
    const newPreviews = previews.filter((_, i) => i !== index);
    const newFiles = values.files.filter((_, i) => i !== index);
    setPreviews(newPreviews);
    setValues({ ...values, files: newFiles });
  };

  return (
    <CommonModal
      title="Adicionar arquivo"
      is_open_modal={adicionarArquivoModal}
      set_is_open_modal={setAdicionarArquivoModal}
      size="lg"
      buttons={
        <CommonButton
          key={`upload-arquivo`}
          color="success"
          onClick={salvarDocumento}
        >
          Enviar
        </CommonButton>
      }
    >
      <div className="row">
        <div className="col-md-12 mb-3">
          <div {...getRootProps()} className="dropzone px-3">
            <input {...getInputProps()} />
            {previews && previews.length > 0 ? (
              <div className="mt-4 d-flex flex-wrap gap-3">
                {previews.map((item, index) => (
                  <div
                    className="dz-image d-flex flex-column justify-content-center text-center mb-3"
                    style={{
                      borderRadius: "20px",
                      background: "linear-gradient(to bottom, #eee, #ddd)",
                      width: "120px",
                      height: "120px",
                      overflow: "hidden",
                    }}
                    key={index}
                  >
                    <div className="dz-details mt-2">
                      <div className="dz-size text-sm text-muted">
                        <span>
                          <strong>
                            {(item.file.size / 1024 / 1024).toFixed(1)}
                          </strong>{" "}
                          MB
                        </span>
                      </div>
                      <div
                        className="dz-filename text-sm text-dark"
                        style={{ maxWidth: "150px" }}
                      >
                        <span>
                          {item.file.name.slice(0, 12) +
                            (item.file.name.length > 12 ? "..." : "")}
                        </span>
                      </div>
                    </div>
                    <a
                      href="#"
                      className="dz-remove text-danger text-sm mt-2 d-block text-center"
                      onClick={(e) => {
                        e.stopPropagation();
                        e.preventDefault();
                        removeFile(index);
                      }}
                    >
                      Remove file
                    </a>
                  </div>
                ))}
              </div>
            ) : (
              <div
                className="d-flex flex-column text-center justify-content-center"
                style={{ minHeight: "230px" }}
              >
                <div className="mb-3">
                  <i className="bx bxs-cloud-upload display-4 text-muted bx bxs-cloud-upload"></i>
                </div>
                <h4 className="text-gray-700 font-medium">
                  Arraste ou clique para enviar outros arquivos.
                </h4>
              </div>
            )}
          </div>
        </div>
      </div>
    </CommonModal>
  );
}

AdicionarArquivoModal.propTypes = {
  modalHook: PropTypes.shape({
    adicionarArquivoModal: PropTypes.bool.isRequired,
    setAdicionarArquivoModal: PropTypes.func.isRequired,
  }).isRequired,
  valuesHook: PropTypes.shape({
    values: PropTypes.object.isRequired,
    setValues: PropTypes.func.isRequired,
  }).isRequired,
  salvarDocumento: PropTypes.func.isRequired,
  previewsHook: PropTypes.shape({
    previews: PropTypes.array.isRequired,
    setPreviews: PropTypes.func.isRequired,
  }),
};

export default AdicionarArquivoModal;
